import React from 'react';
import {Flex, Box} from 'reflexbox';
import './HotelStandin.scss'

export default (props)=> {
  return (
    <Flex>
      <Box width={[1]}className='hotel-standin' flexDirection='column'>
        <img src='/assets/img/hoteldummy.svg' alt="Hotel Platzhalter" />
      </Box>
      <Box width={[0,1,1,1]} className='hotel-standin' flexDirection='column'>
        <img src='/assets/img/hoteldummy.svg' alt="Hotel Platzhalter"/>
      </Box>
      <Box width={[0,0,0,1]} className='hotel-standin' flexDirection='column'>
        <img src='/assets/img/hoteldummy.svg' alt="Hotel Platzhalter"/>
      </Box>
    </Flex>
  );
};
